import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Home } from './pages/Home';
import { Omrade1 } from './pages/Omrade1';
import { Omrade2 } from './pages/Omrade2';
import { Omrade3 } from './pages/Omrade3';
import { OmMig } from './pages/OmMig';
import { DesignPreview } from './pages/DesignPreview';
import { FAQ } from './pages/FAQ';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
        <Route path="/omrade-1" element={<Omrade1 data-id="element-6" />} data-id="element-5" />
        <Route path="/omrade-2" element={<Omrade2 data-id="element-8" />} data-id="element-7" />
        <Route path="/omrade-3" element={<Omrade3 data-id="element-10" />} data-id="element-9" />
        <Route path="/om-mig" element={<OmMig data-id="element-12" />} data-id="element-11" />
        <Route path="/faq" element={<FAQ data-id="element-14" />} data-id="element-13" />
        <Route path="/design-preview" element={<DesignPreview data-id="element-16" />} data-id="element-15" />
      </Routes>
    </BrowserRouter>;
}